import { Pipe, PipeTransform } from '@angular/core';
import { LocalDateTime } from '../types/local-date-time.type';

@Pipe({
	name: 'localDateTimeToDate'
})
export class LocalDateTimeToDatePipe implements PipeTransform {
	transform(localDateTime: LocalDateTime | undefined | null, convertInUserTZ: boolean): Date | undefined | null {
		if (!localDateTime)
			return localDateTime;

		let year = localDateTime[0];
		let month = localDateTime[1];
		let day = localDateTime[2];
		let hours = localDateTime[3];
		let minutes = localDateTime[4];
		let seconds = localDateTime[5] ? localDateTime[5] : 0;
		
		if (convertInUserTZ) {
			return new Date(Date.UTC(year, month - 1, day, hours, minutes, seconds));
		} else {
			return new Date(year, month - 1, day, hours, minutes, seconds);
		}
	}
}